import { useState, useCallback } from 'react';
import Nango from '@nangohq/frontend';
import { useQueryClient } from '@tanstack/react-query';
import {
  INCIDENT_DEFAULT_FIELDS,
  JIRA_PROJECT_FIELDS,
  NANGO,
} from '@elementary/common-ui/constants/queryKeys';
import * as api from 'shared/services/settingsApi';

function useNango() {
  const queryClient = useQueryClient();
  // We need both success and error so that we can tell the difference between a
  // successful call and a call that hasn't yet happened
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const nangoAuth = useCallback(
    (
      providerId: string,
      authorizationParams?: Record<string, string | undefined>,
      params?: Record<string, string>,
      connectionId?: string,
    ) => {
      (async () => {
        setError(false);
        setSuccess(false);

        const {
          host,
          connectionId: nangoConnectionId,
          publicKey,
          hmac,
        } = await api.fetchNango(providerId, connectionId);

        const nango = new Nango({
          host,
          publicKey,
          websocketsPath: '/ws',
        });

        const result = await nango.auth(providerId, nangoConnectionId, {
          params: params || {},
          authorization_params: authorizationParams,
          hmac,
        });

        if ((result as any).connectionId) {
          setSuccess(true);
          setError(false);
        } else {
          setSuccess(false);
          setError(true);
        }
        queryClient.invalidateQueries({ queryKey: [NANGO] });
        if (providerId === 'jira-v2') {
          queryClient.invalidateQueries({
            queryKey: [JIRA_PROJECT_FIELDS],
            exact: false,
          });
          queryClient.invalidateQueries({
            queryKey: [INCIDENT_DEFAULT_FIELDS],
            exact: false,
          });
        }
      })();
    },
    [queryClient],
  );

  return { nangoAuth, success, error };
}

export default useNango;
